import { gql }  from '@apollo/client';

const FETCH_INTERNAL_REFERRALS = gql`
  query ($id: ID!){
    member(id: $id){
      providerReferrals {
        id
        referralStatusCode
        serviceReferralDate
        refServiceSpecialty {
          code
          displayName
        }
        resultingConsult {
          id
          actualStartDate
          initialRequestDate
        }
        createdByPerson {
          firstNm
          lastNm
        }
        referredBy {
          fullName
        }
        sourceConsult {
          id
          actualEndDate
        }
      }
    }
  }
`;

export default FETCH_INTERNAL_REFERRALS;
